/**
 * CONTEÚDO DAS PÁGINAS DE CADA ÁREA E PERGUNTAS FREQUENTES
 * Texto informativo (Provimento 205/2021 da OAB): explica direitos, sem prometer resultado.
 * Revise e ajuste livremente — basta editar este arquivo.
 */

export const AREA_PAGES = {
  previdenciario: {
    seoTitle: "Advogado(a) Previdenciário em Campestre e Poços de Caldas/MG — INSS, Aposentadoria e BPC",
    seoDescription:
      "Aposentadoria (urbana e rural), BPC/LOAS, auxílio-doença, revisão e benefício negado pelo INSS. Atendimento em Campestre e Poços de Caldas/MG.",
    intro: [
      "O INSS nega ou concede com valor menor muitos benefícios por falta de um documento, um vínculo que não aparece no CNIS ou um período rural que não foi comprovado. Na maioria das vezes, o problema tem solução — o que faz diferença é a análise cuidadosa da sua história de trabalho.",
      "Atendemos trabalhadores urbanos e rurais, pessoas com deficiência, idosos e famílias de baixa renda, tanto no pedido administrativo junto ao INSS quanto na Justiça Federal.",
    ],
    faqs: [
      {
        q: "Com que idade posso me aposentar por idade?",
        a: "Pela regra geral atual, mulheres a partir de 62 anos e homens a partir de 65, com tempo mínimo de contribuição. Trabalhadores rurais (segurados especiais) têm regra própria: 55 anos para mulheres e 60 para homens, com 15 anos de atividade rural. Quem já contribuía antes da Reforma da Previdência de 2019 pode ter regras de transição mais vantajosas — por isso vale analisar o seu caso.",
      },
      {
        q: "Trabalhei na roça sem registro. Esse tempo conta?",
        a: "Pode contar. O trabalho rural em regime de economia familiar pode ser comprovado com documentos da época (notas de produtor, ITR, certidões, contratos de parceria, entre outros), complementados por testemunhas. Reunir as provas certas é a parte mais importante desse tipo de pedido.",
      },
      {
        q: "Quem tem direito ao BPC/LOAS?",
        a: "Idosos a partir de 65 anos e pessoas com deficiência de qualquer idade, de família de baixa renda, mesmo que nunca tenham contribuído para o INSS. É necessário estar inscrito e com o CadÚnico atualizado. O BPC paga um salário mínimo por mês, mas não gera 13º nem pensão por morte.",
      },
      {
        q: "O INSS negou meu pedido. E agora?",
        a: "É possível apresentar recurso administrativo ao próprio INSS ou levar o caso à Justiça Federal, dependendo da situação. Guarde a carta de indeferimento: ela mostra o motivo da negativa e orienta qual caminho é melhor.",
      },
      {
        q: "Posso revisar um benefício que já recebo?",
        a: "Em geral, o pedido de revisão deve ser feito em até 10 anos, contados do primeiro pagamento. Se a revisão for reconhecida, podem ser pagas as diferenças dos últimos 5 anos. Cada tipo de revisão tem seus próprios requisitos.",
      },
    ],
  },

  consumidor: {
    seoTitle: "Advogado(a) do Consumidor em Campestre e Poços de Caldas/MG — Bancos, Consignado e Cobranças",
    seoDescription:
      "Empréstimo consignado não contratado, cobranças indevidas, negativação, voos, compras online e planos de saúde. Atendimento em Campestre e Poços de Caldas/MG.",
    intro: [
      "Descontos no benefício que você não reconhece, cobranças que não param, nome negativado sem motivo: o Código de Defesa do Consumidor protege você nessas situações, inclusive contra bancos e grandes empresas.",
      "Analisamos contratos, extratos e faturas para identificar o que foi cobrado indevidamente e buscar a solução — primeiro de forma administrativa, quando possível, e na Justiça quando necessário.",
    ],
    faqs: [
      {
        q: "Apareceu um empréstimo ou cartão consignado no meu benefício que eu não contratei. O que fazer?",
        a: "Não ignore os descontos. Tire o extrato de empréstimos pelo Meu INSS, guarde os comprovantes e procure orientação. Quando a contratação não é comprovada pelo banco, é possível pedir o cancelamento, a suspensão dos descontos e a devolução dos valores — em alguns casos, em dobro.",
      },
      {
        q: "Meu nome foi negativado por uma dívida que não é minha.",
        a: "Faça a consulta no Serasa ou SPC e guarde o comprovante. A inclusão indevida pode ser cancelada judicialmente e, conforme o caso, gerar indenização por danos morais.",
      },
      {
        q: "Preciso reclamar com a empresa antes de procurar um advogado?",
        a: "Não é obrigatório, mas ajuda: registrar a reclamação (SAC, Procon ou consumidor.gov.br) e guardar o protocolo demonstra a tentativa de solução e reforça a prova.",
      },
      {
        q: "Meu voo atrasou ou foi cancelado. Tenho algum direito?",
        a: "A companhia aérea deve prestar assistência (comunicação, alimentação e, conforme o tempo de espera, hospedagem) e oferecer reacomodação ou reembolso. Prejuízos comprovados podem ser indenizados — guarde cartões de embarque, comprovantes de gastos e comunicações da empresa.",
      },
    ],
  },

  familia: {
    seoTitle: "Advogado(a) de Família em Campestre e Poços de Caldas/MG — Divórcio, Pensão, Guarda e Inventário",
    seoDescription:
      "Divórcio, partilha de bens, pensão alimentícia, guarda, união estável e inventário. Atendimento humanizado e sigiloso em Campestre e Poços de Caldas/MG.",
    intro: [
      "Questões de família envolvem afeto, filhos e patrimônio ao mesmo tempo. Conduzimos cada caso com sigilo, escuta e técnica, buscando sempre que possível o acordo — que costuma ser mais rápido, mais barato e menos desgastante para todos.",
      "Quando o acordo não é possível, atuamos com firmeza na defesa dos seus direitos e do melhor interesse das crianças.",
    ],
    faqs: [
      {
        q: "Divórcio pode ser feito em cartório?",
        a: "Em muitos casos, sim: quando o casal está de acordo, o divórcio pode ser feito por escritura pública em cartório, com a presença de advogado. Quando há filhos menores ou não há acordo, é preciso verificar o caminho adequado — às vezes judicial.",
      },
      {
        q: "Como é definido o valor da pensão alimentícia?",
        a: "O valor considera a necessidade de quem recebe e a possibilidade de quem paga. Não existe um percentual fixo em lei. A pensão pode ser revista sempre que essa situação mudar.",
      },
      {
        q: "União estável tem os mesmos direitos do casamento?",
        a: "Em grande parte, sim — inclusive quanto à divisão de bens e à herança. O reconhecimento pode ser feito em cartório ou na Justiça, e a prova da convivência é essencial.",
      },
      {
        q: "Inventário precisa ser judicial?",
        a: "Nem sempre. Quando os herdeiros estão de acordo, o inventário pode ser feito em cartório, o que costuma ser mais rápido. Há prazo para abrir o inventário sem multa no imposto (ITCD), por isso não convém adiar.",
      },
    ],
  },

  trabalhista: {
    seoTitle: "Advogado(a) Trabalhista em Campestre e Poços de Caldas/MG — Rescisão, Horas Extras e Vínculo",
    seoDescription:
      "Para trabalhadores e empresas: verbas rescisórias, horas extras, vínculo sem carteira, defesa em ações trabalhistas e assessoria preventiva. Campestre e Poços de Caldas/MG.",
    intro: [
      "Da contratação à demissão, o trabalhador tem direitos que muitas vezes não são pagos corretamente: horas extras, FGTS, férias, 13º, adicionais e verbas da rescisão.",
      "Conferimos os documentos do contrato de trabalho e calculamos o que é devido antes de qualquer medida.",
      "Também atendemos empregadores: defesa em ações trabalhistas, rescisões, contratos e orientação preventiva para a empresa cumprir a lei e evitar processos.",
    ],
    faqs: [
      {
        q: "Qual o prazo para entrar com ação trabalhista?",
        a: "Até 2 anos depois do fim do contrato de trabalho. Dentro desse prazo, podem ser cobrados os direitos dos últimos 5 anos. Passado o prazo, o direito de cobrar se perde — por isso não deixe para depois.",
      },
      {
        q: "Trabalhei sem carteira assinada. Tenho direitos?",
        a: "Sim. Comprovado o vínculo de emprego, é possível pedir o registro em carteira e o pagamento de todos os direitos do período, como FGTS, férias e 13º. Mensagens, comprovantes de pagamento e testemunhas ajudam na prova.",
      },
      {
        q: "Minha empresa recebeu uma ação trabalhista. O que fazer?",
        a: "Não ignore a citação: ela informa a data da audiência e o prazo para a defesa. Reúna os documentos do funcionário (ficha de registro, holerites, cartões de ponto, recibos e rescisão) e procure orientação o quanto antes.",
      },
      {
        q: "Posso entrar com ação ainda trabalhando na empresa?",
        a: "Pode, mas cada situação merece análise — em alguns casos é possível pedir a rescisão indireta, quando a empresa descumpre obrigações graves do contrato.",
      },
    ],
  },

  imobiliario: {
    seoTitle: "Advogado(a) Imobiliário em Campestre e Poços de Caldas/MG — Usucapião, Aluguel e Contratos",
    seoDescription:
      "Usucapião e regularização de imóveis, contratos de aluguel, despejo e atraso na entrega de imóvel. Atendimento em Campestre e Poços de Caldas/MG.",
    intro: [
      "Imóvel é, muitas vezes, o maior patrimônio da família. Atuamos na regularização de imóveis sem escritura, na análise e revisão de contratos e nos conflitos entre locador e locatário.",
      "Antes de assinar qualquer contrato de compra ou aluguel, uma revisão jurídica evita problemas que custam muito mais caro depois.",
    ],
    faqs: [
      {
        q: "Moro há anos em um imóvel sem escritura. Posso regularizar?",
        a: "Possivelmente, por meio da usucapião, que pode ser feita na Justiça ou diretamente no cartório de registro de imóveis. A lei prevê prazos de posse que variam de 2 a 15 anos, conforme a situação.",
      },
      {
        q: "O reajuste do meu aluguel está correto?",
        a: "O reajuste deve seguir o índice e a periodicidade previstos no contrato. Cobranças fora do combinado ou cláusulas abusivas podem ser revistas.",
      },
      {
        q: "A construtora atrasou a entrega do imóvel. O que posso pedir?",
        a: "Conforme o contrato e o tempo de atraso, é possível pedir multa, indenização pelos prejuízos ou até a rescisão com devolução dos valores pagos.",
      },
    ],
  },
};

export const GENERAL_FAQS = [
  {
    q: "A primeira conversa tem custo?",
    a: "Envie sua mensagem pelo WhatsApp: fazemos uma análise inicial do seu caso e explicamos, de forma clara, os caminhos possíveis e as condições de contratação antes de qualquer compromisso.",
  },
  {
    q: "Vocês atendem online?",
    a: "Sim. Atendemos presencialmente em Campestre e Poços de Caldas/MG e também online, por WhatsApp e videochamada — os documentos podem ser enviados por foto ou PDF.",
  },
  {
    q: "Quais documentos devo levar?",
    a: "Depende do assunto. Ao agendar pelo site, escolha a área do seu caso e veja a lista de documentos para separar. Se não tiver todos, não tem problema: orientamos como conseguir o restante.",
  },
  {
    q: "Minhas informações ficam em sigilo?",
    a: "Sim. Tudo o que você compartilha com o escritório está protegido pelo sigilo profissional da advocacia e pela Lei Geral de Proteção de Dados.",
  },
];
